<template>
  <div von-loading class="loading-container" :class="{'visible': state == 1, 'visible active': state == 2}">
    <div class="toptip">
      <div class="title">{{title}}</div>
    </div>
  </div>
</template>
<style lang='scss' scoped>
  @import "../../scss/mixins.scss";

  .toptip {
    padding: 15px;
    max-width: 300px;
    background-color: rgba(255, 255, 255, 0.95);
    color: #000;
    text-align: center;
    position: relative;
    border-radius: 6px;

    .title {
      line-height: 20px;
      font-size: 14px;

      @include semibold();
    }

    // .add-num {
    //   font-size: 0;
    //   color: #FFC236;
    //   height: 36px;

    //   img {
    //     height: 8px;
    //     width: 8px;
    //   }

    //   .num {
    //     font-size: 36px;
    //     height: 36px;
    //     line-height: 36px;

    //     @include semibold();
    //   }

    //   .unit {
    //     position: relative;
    //     top: -1px;
    //     font-size: 11px;

    //     @include semibold();
    //   }
    // }
  }
</style>
<script>
  const removeElement = (marker) => {
    let el = document.querySelector(marker) || document.querySelector(`[${marker}]`)
    if (el) {
      document.body.removeChild(el)
    }
  }

  function preventDefault (e) {
    e.preventDefault()
  }

  export default {
    data () {
      return {
        title: '',
        state: 0,
        tips: '',
        showSpinner: true
      }
    },

    destroyed () {
      removeElement('von-loading')
    },

    methods: {
      show (options) {
        this.title = options.title
        this.tips = options.tips
        this.showSpinner = !!options.showSpinner

        this.state = 1
        setTimeout(() => {
          this.state = 2
        })

        document.body.addEventListener('touchmove', preventDefault)
      },

      hide () {
        this.state = 1
        setTimeout(() => {
          this.state = 0
          setTimeout(() => {
            this.$destroy()
          })
        }, 300)

        document.body.removeEventListener('touchmove', preventDefault)
      },

      getState () {
        return this.state
      },

      update (options) {
        this.title = options.title
        this.tips = options.tips
        this.showSpinner = !!options.showSpinner
      }
    }
  }
</script>
